<template>
  <div>
    <PageHeader :title="title" :items="items" />
    <div class="d-flex flex-row justify-content-end" style="padding: 12px;">
      <b-button v-if="dadosSolicitacoes.some(solicitacao => solicitacao.st_desligamento === 'S')" variant="danger" @click="cancelarDesligamento">
        Cancelar Desligamento
      </b-button>
    </div>
    <div class="text-center" v-if="loading">
      <b-spinner class="ms-2" variant="primary"></b-spinner>
    </div>

    <div class="d-flex flex-column justify-content-between" v-else>
      <div class="row col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <b-table
                responsive="sm"
                :items="dadosSolicitacoes"
                :fields="camposSolicitacoes"
                per-page="1000"
                striped
              >
                <template v-slot:cell(st_desligamento)="data">
                  <span
                    class="badge badge-pill font-size-12"
                    :class="{
                      'badge-soft-primary': data.value === 'Em andamento',
                      'badge-soft-danger': data.value === 'Descartado',
                      'badge-soft-warning': data.value === 'Solicitado',
                      'badge-soft-success': data.value === 'Concluído',
                    }"
                  >
                    {{ data.value }}
                  </span>
                </template>
                <template v-slot:cell(status)="data">
                  <span
                    class="badge badge-pill font-size-12"
                    :class="{
                      'badge-soft-primary': data.value === 'Enviado',
                      'badge-soft-danger': data.value === 'Rejeitado',
                      'badge-soft-warning': data.value === 'Em Análise',
                      'badge-soft-info': data.value === 'Aprovação do Tomador',
                      'badge-soft-success': data.value === 'Aprovado',
                    }"
                  >
                    {{ data.value }}
                  </span>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="mt-1 d-flex justify-content-between">
                <router-link :to="'/cooperado/contaCapital'">
                  <b-button size="md"> 
                    <i class="mdi mdi-arrow-left-bold-circle"></i>
                    Voltar</b-button>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    
      <div class="row col-md-12 mt-auto">
        <b-card>
          <b-card-title>Informações importantes:</b-card-title>
          <div class="d-flex flex-column">
            <span class="my-1">
              Art. 13: Em qualquer caso de demissão, eliminação e exclusão, o associado tem direito a restituição do capital que integralizou, acrescido de juros e de sobras que tiverem sido creditadas ou a creditar, além de outros créditos em conta corrente, deduzidos os débitos porventura existentes.
            </span>
            <span class="my-1">
              §1º - A restituição de que trata este artigo somente pode ser exigida, depois de aprovação do Balanço Geral do exercício, pela Assembleia Geral Ordinária em que o associado tenha sido desligado da Cooperativa;
            </span>
            <span class="my-1">
              §2º - O Conselho de Administração da Cooperativa pode determinar que a restituição do Capital e dos juros sobre o capital integralizado, de que trata este artigo, seja feita em parcelas iguais e semestrais até 02 (dois) anos, a partir do exercício financeiro seguinte ao do desligamento do associado;
            </span>
          </div>

        </b-card>
      </div>
    </div>


  </div>
</template>
  
<script>
  import PageHeader from "@/components/page-header";
  // const capitalizeString = (str) => {
  //   return str
  //     .split(" ")
  //     .map((word) => {
  //       return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  //     })
  //     .join(" ");
  // };
  export default {
    components: {
      PageHeader,
    },
    data() {
      return {
        title: "Listagem de Solicitações de Desligamento",
        items: [
          {
            text: "Conta Capital",
            active: false,
            href: "/cooperado/contaCapital",
          },
          {
            text: "Listagem de Solicitações de Desligamento",
            active: true
          },
          {
            text: this.$store.state.nrMatricula,
            active: true
          },
        ],
        loading: true,
        loadingCancelarDesligamento: false,
        dadosSolicitacoes: [],
        dados: {
          nr_solicitacao: null,
          // outras propriedades...
        },
        camposSolicitacoes: [
          {
            key: "sq_matricula_desligamento",
            label: "Nº Solicitação",
          },
          {
            key: "dt_usuinc",
            label: "Data Solicitação",
            class: "alinharCelula",
            formatter: (value) => {
              return this.$tools.converteData(value);
            },
          },
          {
            key: "nr_matricula",
            label: "Nº Matrícula",
          },
          {
            key: "sq_motivo_desligamento",
            label: "Motivo",
            formatter: (value) => {
              if(value){
                var motivo = this.optionMotivo.find(
                  (el) => el.sq_motivo_desligamento == value
                );
                if(motivo){
                  return motivo.ds_motivo_desligamento;
                }
              }
              return '';
            }
          },
          {
            key: "ds_justificativa",
            label: "Considerações",
            formatter: (value, row, column) => {
              if(column.sq_motivo_desligamento){
                var motivo = this.optionMotivo.find(
                  (el) => el.sq_motivo_desligamento == column.sq_motivo_desligamento
                );
                if(motivo){
                  return value;
                }
              }
              return '';
            }
          },
          {
            key: "st_desligamento",
            label: "Status",
            formatter: (value) => {
              var status = '';
              switch (value) {
                case 'E':
                  status = 'Em andamento';
                  break;
                case 'C':
                  status = 'Concluído';
                  break;
                case 'D':
                  status = 'Descartado';
                  break;
                case 'S':
                  status = 'Solicitado';
                  break;
                default:
                  status = 'Outro';
              }
              return status;
            }
          },
        ],
        optionMotivo: [],
      };
    },
    async created() {
      this.$tools.fecharMenu();
      await this.preencheTabela();
    },
    methods: {
      async preencheTabela(){
        try {
          const [respSolicitacoes, respMotivo] =
            await Promise.all([
              this.$http.get("api/desligamento/buscarSolicitacoes/"+ this.$store.state.nrMatricula),
              this.$http.get("api/desligamento/buscarMotivos"),
            ]);
            this.dadosSolicitacoes = respSolicitacoes.data
            this.optionMotivo = respMotivo.data
        } catch (error) {
          console.error("Erro ao buscar os contatos:", error);
        } finally {
          this.loading = false;
        }
      },
      async cancelarDesligamento() {
        this.loadingCancelarDesligamento = true;
        const item = {
          nr_matricula: this.$store.state.nrMatricula,
          sq_matricula_desligamento: this.dadosSolicitacoes[0].sq_matricula_desligamento
            ? this.dadosSolicitacoes[0].sq_matricula_desligamento
            : null,
        };

        try {
          await this.$http.post("api/desligamento/geraCancelamentoDesligamento", item)
            .then(() => {
              this.$tools.alerta("Cancelamento enviado com sucesso", "success");
              this.$router.push("/cooperado/contaCapital");
            })
            .catch(() => {
              this.$tools.alerta("Não foi possível cancelar", "error");
            });

          setTimeout(async () => {
            await this.verificarPendenciaAssinatura();
          }, 6000);
        } catch (error) {
          this.$tools.alerta(error, "error");
          console.error("Erro ao cancelar o desligamento:", error);
        } finally {
          this.loadingCancelarDesligamento = false;
        }
      },


      async verificarPendenciaAssinatura() {
        try {
          const response = await this.$http.get("api/assinaturaEletronica/verificarPendenciaAssinaturaEletronica");

          // Verifica se existe documento a ser assinado, se não existe, ele continua o fluxo normal, se existe, ele redireciona para a tela de assinatura
          if (response.data.length > 0) {
            if (response.data[0].TIPOPENDENCIA === "S" && response.data[0].SQUPLOADPENDENCIA !== null) {
              this.$store.commit("VALIDA_ASSINATURA_ELETRONICA", false);
              this.$router.push("/assinaturaEletronica");
            } else {
              this.$store.commit("VALIDA_ASSINATURA_ELETRONICA", true);
              this.$router.push("/");
            }
          }
        } catch (error) {
          this.$tools.alerta(error, "error");
        }
      },
    },
  };
  </script>